import React, {useEffect, useState} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Box} from '@mui/material'
import {ShipToService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Check, X} from "react-feather";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

const ShipToMapping = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tempRow, setTempRow] = useState([]);
    const initialValue = {wamboRespCode: '', wamboShipToCode: '', oneNetShipCode: '', isOneNetShipToNull: false, isInvalid: false, valid: true, validity:''}
    const savedFilters = JSON.parse(localStorage.getItem("Intg"));
    const [selected, setSelected] = useState(savedFilters ? savedFilters : initialValue);
    const [isShipToEmptyChecked, setIsShipToEmptyChecked] = useState(false);
    const [searchParam, setSearchParam] = useState(JSON.parse(localStorage.getItem("IntSearch"))? JSON.parse(localStorage.getItem("IntSearch")) : '');  
    const [rowList,  setRowList] = React.useState([]);

    const columns = [
      {
          field: 'recipientRefCode', headerName: 'Wambo Recipient Ref Code', width: 200,
          renderCell: (params) => (
              <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/integrations/shipToMapping/' + params.row.id}>
                  {params.value}
              </Link>
          )
      },
      {field: 'wamboShipToRefCode', headerName: 'Wambo Ship To Ref Code', width: 200},
      {field: 'oneNetShipToCode', headerName: 'OneNet Ship To Code', width: 200},   
      {
        field: 'isInvalid', headerName: 'Valid', width: 200, renderCell: (params) => (
            <>{params.value === true ? <X color='red'/> : <Check color='green'/>}</>
        )
    },
  ]

  const validityInput = [ {name: "valid"}, {name: "invalid"}]
  
       useEffect(() => {
           ShipToService.getAll()
               .then((response) => {
                 setList(response.data)
               setTempRow(response.data);    
              if(savedFilters){
                setLoading(true);  
                setSelected(JSON.parse(localStorage.getItem("Intg")));
              }            
       });
       }, []);

       const checkHandler = (param) => {
        if(param === 'isOneNetShipToNull'){
          setIsShipToEmptyChecked(!isShipToEmptyChecked)
          setSelected({...selected, isOneNetShipToNull: !isShipToEmptyChecked})
           } 
        }

    const clearSearch = (param) => {
      switch(param){
        case 'wamboRespCode':
          setSelected({...selected,  wamboRespCode: ''}) 
          break;
          case 'wamboShipToCode':    
          setSelected({...selected,  wamboShipToCode: ''}) 
          break;
          case 'oneNetShipCode': 
          setSelected({...selected,  oneNetShipCode: ''}) 
          break;
          default:
          
         }
       }

       const handleChange = (e) => {
        setSelected({...selected, validity: e})
       }

       const detectChange = (e) => {
        setSearchParam(e.target.value);
         }
         
       const filterList = () => {
        let tempShipToArr = []
        let tempInvalidArr = []
        let tempList = tempRow;
       if(selected.wamboRespCode !== ''){
        tempList = tempList?.filter((el) => el?.recipientRefCode !== null && el?.recipientRefCode.toLowerCase().includes(selected.wamboRespCode.toLowerCase()))
        }  
        if(selected.wamboShipToCode !== ''){
          tempList = tempList?.filter((el) => el?.wamboShipToRefCode !== null && el?.wamboShipToRefCode.toLowerCase().includes(selected.wamboShipToCode.toLowerCase()))
        }  
        if(selected.oneNetShipCode !== ''){
          tempList = tempList?.filter((el) => el?.oneNetShipToCode !== null && el.oneNetShipToCode.toLowerCase().includes(selected.oneNetShipCode.toLowerCase()))
        }     
        if(selected.validity === 'valid'){
          tempInvalidArr = tempList;
          tempList = tempInvalidArr?.filter((el) => el?.isInvalid === false);
        }else if(selected.validity === 'invalid'){
          tempInvalidArr = tempList;
          tempList = tempInvalidArr?.filter((el) => el?.isInvalid === true);
        }else if(selected.validity === ''){
        
        }
        if(selected.isOneNetShipToNull === true){
          tempList = tempList?.filter((el) => el?.oneNetShipToCode === null);
        } 
        setList(tempList)   
        setRowList(tempList);    
       }

       const searchKey = (e) => {
        let tempList = [];
        const filterBUffer = []; 
        rowList.forEach((filteredList) => {                    
       if(filteredList?.recipientRefCode.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }else if(filteredList?.wamboShipToRefCode?.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }else if(filteredList.oneNetShipToCode?.toLowerCase().includes(e.toLowerCase())){
            filterBUffer.push(filteredList)
        }       
         tempList = filterBUffer
       })          
       setList(tempList)
      }

      useEffect(() => {
        filterList();     
        localStorage.setItem('Intg', JSON.stringify(selected));
        localStorage.setItem('code', 'Intg');   
      }, [selected]);

    useEffect(() => {
      localStorage.setItem('IntSearch', JSON.stringify(searchParam));
      if(searchParam !== ''){
        searchKey(searchParam)
      }
    },[rowList, searchParam]);   

        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Wambo to OneNet Ship-to Mapping</h1>
                    </header>
                  
                        <form>                            
                                <Grid container spacing={4}>
                                <Grid item xs={12}>
                                    <TextField sx={{ m: 1, minWidth: 200 }}
                                        name="wamboRespCode"                                               
                                        value={selected.wamboRespCode}  
                                        onChange={(e) => {setSelected({...selected, wamboRespCode: e.target.value})}}                            
                                        label="Wambo Recipient Ref Code"
                                        color="primary"                                  
                                            InputProps={{
                                                endAdornment: (
                                            <IconButton
                                              sx={{ visibility: selected.wamboRespCode ? "visible" : "hidden" }}
                                              onClick={() => {clearSearch('wamboRespCode')}}
                                            >
                                              <ClearIcon />
                                            </IconButton>
                                                ),
                                              }}
                                    />     
                                    <TextField sx={{ m: 1, minWidth: 200 }}
                                        name="wamboShipToCode"                                                 
                                        value={selected.wamboShipToCode}  
                                        onChange={(e) => {setSelected({...selected, wamboShipToCode: e.target.value})}}                            
                                        label="Wambo Ship To Ref Code"
                                        color="primary"                                  
                                            InputProps={{
                                                endAdornment: (
                                            <IconButton
                                              sx={{ visibility: selected.wamboShipToCode ? "visible" : "hidden" }}
                                              onClick={() => {clearSearch('wamboShipToCode')}}
                                            >
                                              <ClearIcon />
                                            </IconButton>
                                                ),
                                              }}
                                     />     
                                      <TextField sx={{ m: 1, minWidth: 200 }}
                                        name="oneNetShipCode"                                              
                                        value={selected.oneNetShipCode}  
                                        onChange={(e) => {setSelected({...selected, oneNetShipCode: e.target.value})}}                            
                                        label="OneNet Ship To Code"
                                        color="primary"                                  
                                            InputProps={{
                                                endAdornment: (
                                            <IconButton
                                              sx={{ visibility: selected.oneNetShipCode ? "visible" : "hidden" }}
                                              onClick={() => {clearSearch('oneNetShipCode')}}
                                            >
                                              <ClearIcon />
                                            </IconButton>
                                                ),
                                              }}
                                    />   
                                  <FormControl sx={{ m: 1, minWidth: 200 }}>
                                     <InputLabel>Validity</InputLabel>
                                      <Select value={selected.validity === '' ? '' : selected.validity} onChange={(e) => handleChange(e.target.value)}
                                         endAdornment={
                                           selected.validity !== '' ? (
                                      <IconButton sx={{visibility: selected.validity !== ''? "visible": "hidden"}} 
                                       onClick={() => {setSelected({
                                         ...selected, 
                                        validity: ''})}}><ClearIcon/></IconButton>
                                           ) : (
                                            false
                                          )
                                        }
                                       >
                                        {validityInput?.map((el) => (
                                       <MenuItem    value={el.name}>
                                           {el.name}
                                      </MenuItem>
                                           ))}      
                                  
                                     </Select>
                                 </FormControl>
                                    <FormControlLabel sx={{ m: 1}} control={<Checkbox
                                       checked={selected.isOneNetShipToNull}
                                       onChange={() => { checkHandler('isOneNetShipToNull')}}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                     /> } label="Empty OneNet Ship-to Code" />     
                                     {/*                                           
                                       <FormControlLabel sx={{ m: 1}} control={<Checkbox
                                       checked={selected.isInvalid}
                                       onChange={() => { checkHandler('isInvalid')}}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                     /> } label="Invalid" />    
                                        <FormControlLabel sx={{ m: 1}} control={<Checkbox
                                       checked={selected.valid}
                                       onChange={() => { checkHandler('valid')}}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                     /> } label="Valid" />   */}
                                  </Grid>
                              
                                </Grid>                                                      
                              </form>
                              <Grid item xs={10}>&nbsp;</Grid>
                        <Grid item xs={12}>
                        <Box
                            component="form"
                            sx={{'& > :not(style)': { m: 1, width: '25ch' }}}
                           // style={{float: "right"}}
                            noValidate
                            autoComplete="on"
                          >   
                          <TextField type="text" defaultValue={searchParam} label="Search" variant="standard" onChange={detectChange}  />
                         </Box>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                showQuickFilter={true}
                               />
                          
                        </Grid>
                   
                </Container>
            </React.Fragment>
        );
}

export default ShipToMapping;